export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f28e79f95adceb4cc33a99c9307b7057d07d65285&name=fetchTypeahead!'